import apiClient from "./apiClient";

/**
 * Verify user email with the provided userId and verification token
 * @param {string} userId - The user ID to verify
 * @param {string} verificationToken - The verification token
 * @returns {Promise<Object>} - The verification result
 */
export const verifyEmail = async (userId, verificationToken) => {
  try {
    const response = await apiClient.get("/api", {
      params: {
        action: "EMAIL_VERIFICATION",
        userId,
        verificationToken,
      },
    });

    return response.data;
  } catch (error) {
    // Handle different types of errors
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.error("Error response:", error.response.data);
      return {
        success: false,
        message: error.response.data.message || "Verification failed",
        data: { verified: false },
      };
    } else if (error.request) {
      // The request was made but no response was received
      console.error("Error request:", error.request);
      return {
        success: false,
        message: "No response from server. Please try again later.",
        data: { verified: false },
      };
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error("Error:", error.message);
      return {
        success: false,
        message: "An error occurred during verification.",
        data: { verified: false },
      };
    }
  }
};
export const resendEmailVerification = async (userId) => {
  try {
    const response = await apiClient.get("/lifewink/admin/generateVerification", {
      params: {
        userId,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error resending email verification:", error);
    throw error;
  }
};
